'use strict';

// Load fonts
var WebFontConfig = {
	typekit: { id: 'dtd6ojb' },
	timeout: 2000,
};

(function (d) {
	var wf = d.createElement('script'), s = d.scripts[0];
	wf.src = 'https://ajax.googleapis.com/ajax/libs/webfont/1.6.26/webfont.js';
	wf.async = true;
	s.parentNode.insertBefore(wf, s);
})(document);

// Init mobile menu and off-canvas
const mobileMenu = new MobileMenu();
document.addEventListener('mobilemenu-init-done', () => {
	var offCanvas = new OffCanvas({
		debug: false,
		overlay: true,
	})
});
mobileMenu.init();